var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Menu.AddCustomerMenu"),
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "600px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: { "label-width": "40px", "label-position": "left", inline: "" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.Search") } },
            [
              _c("cargo-advance-select", {
                ref: "tenantSel",
                staticStyle: { width: "200px" },
                attrs: {
                  "select-type": _vm.selectTypeNames.TENANT,
                  cache: false,
                  filterable: "",
                  "custom-label": _vm.companyLabel,
                  "callback-params": { key: "relateTenantId" },
                  "callback-method-type": "value",
                  "default-value": String(_vm.txtSearch) || ""
                },
                on: { parentCallBack: _vm.tenantIdChangeHandler }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.removeSelectEvent }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Removed")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.enterHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.OK")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }